var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#444;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1240 -417)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17,
    height: 17,
    transform: "translate(1240 417)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1240.708 417.708)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.125,
    cy: 2.125,
    r: 2.125,
    transform: "translate(5.667 5.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.033,10.917a1.169,1.169,0,0,0,.234,1.289l.042.043a1.417,1.417,0,1,1-2,2l-.042-.042a1.178,1.178,0,0,0-2,.836v.12a1.417,1.417,0,0,1-2.833,0V15.1a1.169,1.169,0,0,0-.765-1.07,1.169,1.169,0,0,0-1.289.234l-.043.042a1.417,1.417,0,1,1-2-2l.043-.043a1.178,1.178,0,0,0-.836-2h-.12a1.417,1.417,0,0,1,0-2.833H2.48a1.169,1.169,0,0,0,1.07-.765,1.169,1.169,0,0,0-.234-1.289l-.043-.043a1.417,1.417,0,1,1,2-2l.042.043a1.169,1.169,0,0,0,1.289.234h.057a1.169,1.169,0,0,0,.708-1.07v-.12a1.417,1.417,0,1,1,2.833,0V2.48a1.178,1.178,0,0,0,2,.836l.042-.042a1.417,1.417,0,1,1,2,2l-.042.042a1.169,1.169,0,0,0-.234,1.289v.057a1.169,1.169,0,0,0,1.07.708h.12a1.417,1.417,0,0,1,0,2.833H15.1A1.169,1.169,0,0,0,14.033,10.917Z",
    transform: "translate(-1 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.208f3b1cb66926a8b1b745677c53058d.svg";
export { ForwardRef as ReactComponent };